// validationSchema.ts
import * as yup from "yup";

export const purchaseOrderSchema = yup.object({
  damageFormId: yup.number().required("Damage form ID is required"),
  dealer: yup.string().required("Dealer is required"),
  tenant: yup.string().required("Tenant is required"),
  language: yup.string().required("Language is required"),
  purchaseOrderDate: yup.string().required("Purchase order date is required"),
  ivaPercentage: yup.number().required("Iva percentage date is required"),
  ivaPrice: yup.number().required("Iva price is required"),
  ivaTotalPrice: yup.number().required("Iva total price is required"),
  totalGrossPrice: yup.number().required("Total gross price is required"),
  totalNetPrice: yup.number().required("Total net price is required"),
  totalPrice: yup.number().required("Total price is required"),
  repairShopAddress: yup.string().required("Repair shop address is required"),
  repairShopBillingAddress: yup.string().required("Repair shop billing address is required"),
  repairShopSiren: yup.string().required("SIREN is required"),
  repairShopPhone: yup.string().required("Repair shop phone is required"),
  repairShopMail: yup.string().email("Invalid email").required("Repair shop email is required"),
  purchaseElements: yup.array().of(yup.object()).required("Purchase elements are required"),
  
  /*
  damageDetail: yup.string().required("Damage detail is required"), // Is it tho? Where would I set it?
  plate: yup.string().required("Plate is required"),
  repairShopName: yup.string().required("Repair shop name is required"),
  repairShopCity: yup.string().required("Repair shop city is required"),
  repairShopAddressCity: yup.string().required("Repair shop city is required"),
  repairShopSapId: yup.string().nullable(), // Optional ??
  vin: yup.string().required("VIN is required"),
  gridAmount: yup.mixed().required("Grid amount is required"), // Is it tho?
  */
});

export type PurchaseOrderFormTypes = yup.InferType<typeof purchaseOrderSchema>;
